import React, { Component } from 'react';



class dog extends Component {
    // state = {

    // }
    // handleChange = (e) => {
    //     console.log(e);
    // }
    // handleSubmit = (e) => {
    //     console.log(e);
    // }
    render() {



        return (
            <section>

            <section className="container section">

            <h4 className="titleENG center">My Dog</h4>
                <div className="row">
                    <div className="col s12 l6">
                        <img src="../img34/0.jpg" alt="" className="responsive-img materialboxed"/>
                    </div>
                    <div className="col s12 l4 offset-l2">
                        <h4 className="black-text school">Shiyi</h4>
                        <div className="YXdetail">
                            <p className="YXdetailP">Name: Shiyi</p>
                            <p className="YXdetailP">Gender: Male</p>
                            <p className="YXdetailP">Born: November 22, 2021(age 3 years), Canada</p>
                            <p className="YXdetailP">Weight: 55kg</p>
                        </div>
                    </div>
                </div>

                <h4 className="titleENG center">Some Pictures...</h4>    

                <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img34/12.png" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img34/11.png" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img34/10.png" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img34/9.png" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img34/8.png" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img34/7.png" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img34/6.png" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img34/5.png" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img34/4.png" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img34/3.png" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img34/2.png" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img34/1.png" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>
        
       
            </section>
           
            </section>
        )
    }
}




export default dog
